import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {EnquireNowFormComponent} from './enquire-now-form.component';
import {MatButtonModule, MatInputModule, MatSelectModule} from '@angular/material';
import {CaptchaModule} from '../../common/captcha/captcha.module';

@NgModule({
    declarations: [EnquireNowFormComponent],
    exports: [EnquireNowFormComponent],
    imports: [FormsModule, MatInputModule, MatSelectModule, MatButtonModule, CaptchaModule]
})
export class EnquireNowFormModule {
}
